
interface HeaderProps {
  title?: string;
  showBack?: boolean;
  rightAction?: React.ReactNode;
}

export default function Header({ title, showBack, rightAction }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-teal-500 to-blue-500 text-white z-40">
      <div className="flex items-center justify-between h-14 px-4">
        <div className="flex items-center gap-3">
          {showBack && (
            <button
              onClick={() => window.history.back()}
              className="w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl" />
            </button>
          )}
          {title && <h1 className="text-lg font-bold">{title}</h1>}
        </div>
        {rightAction && <div>{rightAction}</div>}
      </div>
    </header>
  );
}
